
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Gösterge panosu oluştur',
	'dashboard': 'Gösterge Panosu',
	'dashboardTemplate': 'Gösterge panosu şablonu',
	'createAV': 'Oluştur',
	'createAvEditNameLabel': '1. Görünümünüzü adlandırın',
	'createAvSelectTemplateLabel': '2. Bir şablon seçin',
	'tabLayoutLabel': 'Sekmeli şablon',
	'infographicsLayoutLabel': 'İnfografik şablonu',
	'singlePageLayoutLabel': 'Tek sayfa şablonu',
	'customLayoutLabel': 'Özel şablon',
	'freeformTemplate': 'Serbest biçim',
	'freeformTemplateDesc': 'Serbest biçimli düzendeki görselleştirmeler, ekran boyutuna bakılmaksızın tam olarak onu boyutlandırdığınız ve yerleştirdiğiniz şekilde görüntülenir. Diğer düzenlerde, görselleştirmelerin boyutu ve konumu ekrana sığdırılacak şekilde ayarlanır.',
	'NoTemplate': 'Serbest biçim',
	'Template1': 'Boş',
	'Template2': 'Başlık 1 x 2',
	'Template3': '1 üzerinde 2',
	'Template4': '1 üzerinde 4',
	'Template5': 'Altbilgi 1 x 2',
	'Template6': '1 üzerinde 1 yanında 3',
	'Template7': '1 üzerinde 3 yanında 4',
	'Template8': '3 x 2 üzerinde 2',
	'Template9': '2 x 2',
	'Template10': '1 üzerinde 2 x 2 yanında 1 x 2',
	'Template11': '1 x 2 üzerinde 3 x 1',
	'Template12': '1 x 2 yanında 1 üzerinde 2',
	'Template13': '1 yanında 1 çarpı 2 yanında 1 çarpı 4',
	'Template22': '1 bölü 2 çarpı 2',
	'Template14': '1 yanında 1',
	'Template15': '1 bölü 1 yanında 1',
	'Template16': '1 yanında 1 bölü 1',
	'Template17': '1 bölü 1 yanında 1 bölü 1',
	'Template18': '1 bölü 1 yanında 1',
	'Template19': '1 bölü 2 yanında 1',
	'Template20': '1 bölü 2 çarpı 1',
	'Template21': '1 bölü 1 bölü 2 çarpı 1',
	'Template23': 'Dropzone ile Boşalt',
	'Infographics1': 'Boş',
	'Infographics2': '4 satır',
	'Infographics3': 'Üstbilgi içeren 4 satır',
	'Infographics4': '2 x 4',
	'Infographics5': '2 x 2 ile büyük üst görüntü',
	'Infographics6': 'Dikey boşluk ile 2 x 4',
	'Infographics7': 'Basamaklandırılmış 2 x 4',
	'Infographics8': 'Tenis kortu',
	'Infographics9': '3 x 4',
	'Infographics10': '4 x 8',
	'createAvDashboardLabel': 'Düzen',
	'dashboard_template_save_success': 'Gösterge panosu şablonunuz kaydedildi.',
	'dashboard_template_prefix': 'Şablon: "%{name}"',
	'dashboard_template_filters_removed': 'Tuval üzerindeki süzgeçler kaldırıldı.',
	'createAvTabLabel': 'Sekmeli',
	'createAvInfographicsLabel': 'İnfografik',
	'createAvSinglepageLabel': 'Tek Sayfa',
	'createAvCustomLabel': 'Özel',
	'loadMoreLabel': 'Daha fazla yükle...',
	'backLabel': 'Geri git',
	'addSourceLabel': 'Kaynak ekle',
	'pinLabel': 'Sabitle',
	'errorLoadingDataSetMetaData': 'Meta veriler okunurken bir hata oluştu',
	'errorLoadingDataSets': 'Veri kümeleri listesi yüklenirken hata oluştu',
	'errorLoadingDataSet': '"%{datasetName}" veri kümesi için meta veri yüklenmedi. Lütfen ayrıntılar için sistem yöneticinizle görüşün.',
	'okButton': 'Tamam',
	'createButton': 'Oluştur',
	'cancelButton': 'İptal',
	'copyButton': 'Kopyala',
	'selectTemplateLabel': 'Bir şablon seçin',
	'createBoardTitle': 'Gösterge panosu oluştur',
	'createBoardSubtitle': 'Gösterge panonunuz için bir şablon seçin',
	'noSourcesSelectedLabel': 'Kaynak seçilmedi',
	'find_label': 'Bul',
	'noDashboardFound': 'Gösterge panosu alınamıyor. Hikaye artık yok veya onu görüntülemek için yeterli ayrıcalıklara sahip değilsiniz.',
	'errorLabel': 'Hata',
	'defaultName': 'Yeni gösterge panosu',
	'noDashboardCapability': 'Gösterge panosu uygulamasını çalıştırma yeteneğiniz yok',
	'noCapabilityForCreateDashboard': 'Seçilen varlıklara karşı bir gösterge panosu oluşturmak için gerekli yeteneğiniz yok',
	'noCapabilityForEdit': 'Bu gösterge panosunu düzenleme yeteneğine sahip değilsiniz',
	'noCapabilityForSave': 'Bu gösterge panosunu kaydetme yeteneğine sahip değilsiniz',
	'noCapabilityForPaste': 'Kopyalanan pencere araçlarını bu görünüme yapıştırabilme yeteneğine sahip değilsiniz',
	'noCapabilityForPin': 'Bu pini ekleme yeteneğine sahip değilsiniz',
	'noCapabilityForLaunchInExplore': 'Kopyalanan pencere araçlarını bir keşifte başlatma yeteneğine sahip değilsiniz',
	'noDashboardPermission': 'Bu gösterge panosunu görüntülemek için yeterli ayrıcalıklara sahip değilsiniz',
	'sourceNotFound': 'İlişkili kaynağı "%{sourceName}" kullanılamadığı için görselleştirme yüklenemiyor',
	'cmDuplicateName': 'Bu ada sahip bir öğe zaten var. Başka bir ad deneyin',
	'cmEmptySelection': 'Gösterge panosu silindi. Yeni gösterge panosu olarak kaydetmeyi deneyin.',
	'propTheme_v1': 'Görsel tema',
	'propTheme': 'Tema',
	'legacyThemeLabel': 'Eski',
	'carbonGrey10Label': 'Karbon X Açık',
	'carbonGrey100Label': 'Karbon X Koyu',
	'titleTextLabel': 'Başlık',
	'titleSmallTextLabel': 'Küçük Başlık',
	'subtitleTextLabel': 'Alt başlık',
	'bodyTextLabel': 'Gövde',
	'bodySmallTextLabel': 'Küçük Gövde',
	'captionTextLabel': 'Başlık',
	'quoteTextLabel': 'Alıntı',
	'quoteSmallTextLabel': 'Küçük Alıntı',
	'responsiveTextLabel': 'Otomatik boyut',
	'mediaWidgetLabel': 'Ortam',
	'webpageWidgetLabel': 'Web Sayfası',
	'imageWidgetLabel': 'Resim',
	'textWidgetLabel': 'Metin',
	'notebookWidgetLabel': 'Not Defteri',
	'multipurposeWidgetLabel': 'Çok amaçlı',
	'textPlaceHolder': 'Metni düzenlemek için tıklatın',
	'titlePlaceHolder': 'Başlığı düzenlemek için tıklatın',
	'toggleEditModeLabel': 'Düzenlemek için geçiş yap',
	'togglePreviewModeLabel': 'Önizlemek için geçiş yap',
	'editDashboardCoachMarkTitle': 'Gösterge panosunu düzenle',
	'editDashboardCoachMarkContents': 'Bu gösterge panosunu düzenlemek için kalem simgesini tıklatın.',
	'addDataCoachMarkTitle': 'Veri ekle',
	'addDataDashboardCoachMarkContents': 'Veri panosundan gösterge panonuza verileri sürükleyip bırakın.',
	'pageSelectWarning': 'Lütfen bir sekme seçin.',
	'screenshot_label': 'Gösterge Panosu %{title}',
	'screenshot_label_tab': '%{title} gösterge panosunun %{tabName} sekmesi',
	'dataAssetPropertiesLabel': 'Görselleştirme özellikleri',
	'modelFilter': 'Süzgeç',
	'invertSelectionToolTip': 'Süzgeç seçimlerini ters çevir',
	'clearFilterValueToolTip': 'Süzgeç değerlerini temizle',
	'invertFilterSelection': 'Ters Çevir',
	'clearTextFilterValue': 'Temizle',
	'filterConditionLabel': 'Süzgeç koşulu',
	'applyFilter': 'Süzgeç uygula',
	'itemCountText': '%{itemCount} Öğe seçildi',
	'itemExcludeCountText': '%{itemCount} Öğe dışlandı',
	'moreMembers': 'Daha fazlasını göster...',
	'searchHierarchyMembers': 'Üyeleri bulmak için aramayı kullan...',
	'propHideEmpty': 'Boş olanı gizle',
	'propColorOrder': 'Renk düzeni',
	'propElementColor': 'Görselleştirme öğesi rengi',
	'propLineColor': 'Çizgi rengi',
	'propLineAndSymbolColor': 'Çizgi ve simge rengi',
	'propColumnColor': 'Sütun rengi',
	'propBarColor': 'Çubuk rengi',
	'propWordColor': 'Sözcük rengi',
	'propAreaColor': 'Alan rengi',
	'propRadialbarColor': 'Radyal çubuk rengi',
	'propColorPalettes': 'Renk paletleri',
	'propDashboardColorPalette': 'Geçerli gösterge panosu paleti',
	'propNewDashboardPaletteLabel': 'Özel gösterge panosu paleti oluştur',
	'propDashboardChangePaletteLink': 'Gösterge panosu paletini değiştir',
	'propHideLeafNode': 'Yaprak etiketleri gizle',
	'propOpacity_v1': 'Pencere öğesi opaklığı',
	'propOpacity': 'Pencere öğesi opaklığı (%)',
	'propOpacityDescription': 'Nesneyi daha fazla veya daha az opak yapın. 0 ila 100 arasında bir değer girin',
	'addATab': 'Yeni bir sekme ekle',
	'propFredIsRed': 'Renk tutarlılığı',
	'areaChartCaption': 'Alan',
	'areaChartDataSlot_categoriesLabel': 'Eksen etiketi',
	'areaChartDataSlot_valuesLabel': 'Değer',
	'areaChartProp_colorPaletteLabel': 'Renk paletleri',
	'areaChartProp_lineColorLabel': 'Alan rengi',
	'areaChartProp_interpolationLabel': 'Düz çizgiler',
	'areaChartProp_interpolationDescription': 'Veri noktalarını bağlayan çizgiler eğri.',
	'areaChartProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'areaChartProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'areaChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'areaChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'areaChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'areaChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'barChartCaption': 'Çubuk',
	'barChartDataSlot_categoriesLabel': 'Eksen etiketi',
	'barChartDataSlot_valuesLabel': 'Değer',
	'barChartProp_colorPaletteLabel': 'Renk paletleri',
	'barChartProp_elementColorLabel': 'Çubuk rengi',
	'barChartProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'barChartProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'barChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'barChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'barChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'barChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'barChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'barChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'columnChartCaption': 'Sütun',
	'columnChartDataSlot_categoriesLabel': 'Eksen etiketi',
	'columnChartDataSlot_valuesLabel': 'Değer',
	'columnChartProp_colorPaletteLabel': 'Renk paletleri',
	'columnChartProp_elementColorLabel': 'Sütun rengi',
	'columnChartProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'columnChartProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'columnChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'columnChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'columnChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'columnChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'bubbleChartCaption': 'Kabarcık',
	'bubbleChartDataSlot_xAxisLabel': 'Yatay eksen',
	'bubbleChartDataSlot_yAxisLabel': 'Dikey eksen',
	'bubbleChartDataSlot_sizeLabel': 'Boyut:',
	'bubbleChartDataSlot_colorLabel': 'Renk:',
	'bubbleChartProp_colorPaletteLabel': 'Renk paletleri',
	'bubbleChartProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'bubbleChartProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'bubbleChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'bubbleChartProp_hideLegendLabel': 'Açıklamayı gizle',
	'bubbleChartProp_hideLegendDescription': 'Açıklamayı gizleyin.',
	'bubbleChartProp_legendPositionLabel': 'Açıklama konumu',
	'lineChartCaption': 'Çizgi',
	'lineChartDataSlot_categoriesLabel': 'Eksen etiketi',
	'lineChartDataSlot_valuesLabel': 'Değer',
	'lineChartProp_colorPaletteLabel': 'Renk paletleri',
	'lineChartProp_lineColorLabel': 'Çizgi ve simge rengi',
	'lineChartProp_symbolShapeLabel': 'Simge şekli',
	'lineChartProp_hideSymbolsLabel': 'Simgeleri Gizle',
	'lineChartProp_hideSymbolsDescription': 'Simgeleri gizle',
	'lineChartProp_hideDataLinesLabel': 'Çizgileri gizle',
	'lineChartProp_hideDataLinesDescription': 'Çizgileri gizle',
	'lineChartProp_interpolationLabel': 'Düz çizgiler',
	'lineChartProp_interpolationDescription': 'Veri noktalarını bağlayan çizgiler eğri.',
	'lineChartProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'lineChartProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'lineChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'lineChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'lineChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'lineChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'packedBubbleChart1CatCaption': 'Paketlenmiş kabarcık',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategoriler',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Boyut:',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Renk paletleri',
	'packedBubbleChart1CatProp_elementColorLabel': 'Kabarcık rengi',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Etiketi gizle',
	'packedBubbleChart1CatProp_hideValueLabel': 'Değeri gizle',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Boş olanı gizle',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'heatChartCaption': 'Isı',
	'heatChartDataSlot_valuesLabel': 'Isı:',
	'heatChartDataSlot_xAxisLabel': 'Yatay eksen',
	'heatChartDataSlot_yAxisLabel': 'Dikey eksen',
	'heatChartProp_colorPaletteLabel': 'Renk paletleri',
	'heatChartProp_heatScalePaletteLabel': 'Renk düzeni',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'heatChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'heatChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'heatChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'heatChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'heatChartProp_hideLegendLabel': 'Açıklamayı gizle',
	'heatChartProp_hideLegendDescription': 'Açıklamayı gizleyin.',
	'heatChartProp_legendPositionLabel': 'Açıklama konumu',
	'pieChartCaption': 'Pasta',
	'pieChartDataSlot_categoriesLabel': 'Kategoriler',
	'pieChartDataSlot_valuesLabel': 'Değer',
	'pieChartProp_colorPaletteLabel': 'Renk paletleri',
	'pieChartProp_hideRadialValueLabel': 'Değeri gizle',
	'pieChartProp_pieAsDonutLabel': 'Halka grafik olarak görüntüle',
	'pieChartProp_pieAsDonutDescription': 'Halka grafik olarak görüntüle',
	'pieChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'pieChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'pieChartProp_hideLegendLabel': 'Açıklamayı gizle',
	'pieChartProp_hideLegendDescription': 'Açıklamayı gizleyin.',
	'pieChartProp_legendPositionLabel': 'Açıklama konumu',
	'map1measureCaption': 'Harita',
	'map1measureDataSlot_categoriesLabel': 'Bölgeler',
	'map1measureDataSlot_valuesLabel': 'Bölge ısısı',
	'map1measureProp_colorPaletteLabel': 'Renk paletleri',
	'map1measureProp_heatScalePaletteLabel': 'Renk düzeni',
	'map1measureProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'map1measureProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'map1measureProp_suppressZerosLabel': 'Boş olanı gizle',
	'map1measureProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'map1measureProp_hideLegendLabel': 'Açıklamayı gizle',
	'map1measureProp_hideLegendDescription': 'Açıklamayı gizleyin.',
	'map1measureProp_legendPositionLabel': 'Açıklama konumu',
	'radialChartCaption': 'Radyal',
	'radialChartDataSlot_categoriesLabel': 'Kategoriler',
	'radialChartDataSlot_valuesLabel': 'Değer',
	'radialChartProp_colorPaletteLabel': 'Renk paletleri',
	'radialChartProp_elementColorLabel': 'Radyal çubuk rengi',
	'radialChartProp_hideRadialTitleLabel': 'Başlığı gizle',
	'radialChartProp_hideRadialValueLabel': 'Değeri gizle',
	'radialChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'radialChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'radialChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'radialChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'pointChart1catCaption': 'Nokta',
	'pointChart1catDataSlot_valuesLabel': 'Değer',
	'pointChart1catDataSlot_categoriesLabel': 'Eksen etiketi',
	'pointChart1catProp_colorPaletteLabel': 'Renk paletleri',
	'pointChart1catProp_elementColorLabel': 'Şekil rengi',
	'pointChart1catProp_symbolShapeLabel': 'Simge şekli',
	'pointChart1catProp_symbolFillLabel': 'Doldurma şekli',
	'pointChart1catProp_symbolFillDescription': 'Simgeler için doldurma rengini görüntüleyin.',
	'pointChart1catProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'pointChart1catProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'pointChart1catProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'pointChart1catProp_suppressZerosLabel': 'Boş olanı gizle',
	'pointChart1catProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'scatterPlotChartNoCatCaption': 'Dağılım çizimi',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Yatay eksen',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Dikey eksen',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Renk paletleri',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Öğe rengi',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Simge şekli',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Doldurma şekli',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Simgeler için doldurma rengini görüntüleyin.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'radialBarChartCaption': 'Radyal çubuk',
	'radialBarChartDataSlot_categoriesLabel': 'Kategoriler',
	'radialBarChartDataSlot_valuesLabel': 'Değer',
	'radialBarChartProp_colorPaletteLabel': 'Renk paletleri',
	'radialBarChartProp_elementColorLabel': 'Radyal çubuk rengi',
	'radialBarChartProp_hideRadialTitleLabel': 'Başlığı gizle',
	'radialBarChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'radialBarChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'radialBarChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'radialBarChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'lineColumnComboChartCaption': 'Çizgi ve sütun',
	'lineColumnComboChartDataSlot_categoryLabel': 'Eksen etiketi',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Çizgi değeri',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Sütun değeri',
	'lineColumnComboChartProp_colorPaletteLabel': 'Renk paletleri',
	'lineColumnComboChartProp_elementColorLabel': 'Sütun rengi',
	'lineColumnComboChartProp_lineColorLabel': 'Çizgi ve simge rengi',
	'lineColumnComboChartProp_symbolShapeLabel': 'Simge şekli',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Simgeleri gizle',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Simgeleri gizle',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Çizgileri gizle',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Çizgileri gizle',
	'lineColumnComboChartProp_interpolationLabel': 'Düz çizgiler',
	'lineColumnComboChartProp_interpolationDescription': 'Veri noktalarını bağlayan çizgiler eğri.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Izgara çizgilerini gizle',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Izgara çizgilerini gizle',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Eksen başlığı etiketlerini gizle',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Eksenler için başlıkları gizleyin.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'lineColumnComboChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'lineColumnComboChartProp_hideLegendLabel': 'Açıklamayı gizle',
	'lineColumnComboChartProp_hideLegendDescription': 'Açıklamayı gizleyin.',
	'lineColumnComboChartProp_legendPositionLabel': 'Açıklama konumu',
	'summaryCaption': 'Özet',
	'areaName': 'Alan',
	'areaDescription': 'Alan',
	'areaDataSlot_colorLabel': 'Renk:',
	'areaDataSlot_valuesLabel': 'Değer',
	'areaDataSlot_categoriesLabel': 'Eksen etiketi',
	'bubbleName': 'Kabarcık',
	'bubbleDescription': 'Kabarcık',
	'bubbleDataSlot_yAxisLabel': 'Dikey eksen',
	'bubbleDataSlot_xAxisLabel': 'Yatay eksen',
	'bubbleDataSlot_sizeLabel': 'Boyut:',
	'bubbleDataSlot_colorLabel': 'Renk:',
	'clusterBarName': 'Çubuk',
	'clusterBarDescription': 'Çubuk',
	'clusterBarDataSlot_colorLabel': 'Renk:',
	'clusterBarDataSlot_valuesLabel': 'Değer',
	'clusterBarDataSlot_categoriesLabel': 'Eksen etiketi',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Değer',
	'clusterColumnName': 'Sütun',
	'clusterColumnDescription': 'Sütun',
	'clusterColumnDataSlot_colorLabel': 'Renk:',
	'clusterColumnDataSlot_valuesLabel': 'Değer',
	'clusterColumnDataSlot_categoriesLabel': 'Eksen etiketi',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Değer',
	'clusterLineName': 'Çizgi',
	'clusterLineDescription': 'Çizgi',
	'clusterLineDataSlot_colorLabel': 'Renk:',
	'clusterLineDataSlot_valuesLabel': 'Dikey eksen',
	'clusterLineDataSlot_categoriesLabel': 'Yatay eksen',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Değer',
	'gridName': 'Kılavuz',
	'gridDescription': 'Kılavuz',
	'gridDataSlot_grid_colsLabel': 'Sütun',
	'heatName': 'Isı',
	'heatDescription': 'Isı',
	'heatDataSlot_yAxisLabel': 'Dikey eksen',
	'heatDataSlot_xAxisLabel': 'Yatay eksen',
	'heatDataSlot_valuesLabel': 'Isı:',
	'lineColumnComboName': 'Çizgi ve sütun',
	'lineColumnComboDescription': 'Çizgi ve sütun',
	'lineColumnComboDataSlot_lineValueLabel': 'Çizgi değeri',
	'lineColumnComboDataSlot_categoryLabel': 'Eksen etiketi',
	'lineColumnComboDataSlot_columnValueLabel': 'Sütun değeri',
	'mapName': 'Eski Harita',
	'mapDescription': 'Eski Harita',
	'mapDataSlot_sizeLabel': 'Nokta boyutu',
	'mapDataSlot_valuesLabel': 'Bölge ısısı',
	'mapDataSlot_sizeHeatLabel': 'Nokta ısısı',
	'mapDataSlot_categoriesLabel': 'Bölgeler',
	'packedBubbleName': 'Paketlenmiş kabarcık',
	'packedBubbleDescription': 'Paketlenmiş kabarcık',
	'packedBubbleDataSlot_sizeLabel': 'Boyut:',
	'packedBubbleDataSlot_colorLabel': 'Renk:',
	'packedBubbleDataSlot_categoriesLabel': 'Kategoriler',
	'pieName': 'Pasta',
	'pieDescription': 'Pasta',
	'pieDataSlot_valuesLabel': 'Değer',
	'pieDataSlot_categoriesLabel': 'Kategoriler',
	'playerName': 'Veri oynatıcı',
	'playerDescription': 'Veri oynatıcı',
	'playerDataSlot_categoriesLabel': 'Eksen etiketi',
	'pointName': 'Nokta',
	'pointDescription': 'Nokta',
	'pointDataSlot_colorLabel': 'Renk:',
	'pointDataSlot_valuesLabel': 'Değer',
	'pointDataSlot_categoriesLabel': 'Eksen etiketi',
	'radialName': 'Radyal',
	'radialDescription': 'Radyal',
	'radialDataSlot_valuesLabel': 'Değer',
	'radialDataSlot_maxSizeLabel': 'Maksimum değer',
	'radialDataSlot_categoriesLabel': 'Kategoriler',
	'radialBarName': 'Radyal çubuk',
	'radialBarDescription': 'Radyal çubuk',
	'radialBarDataSlot_valuesLabel': 'Değer',
	'radialBarDataSlot_categoriesLabel': 'Kategoriler',
	'scatterPlotName': 'Dağılım çizimi',
	'scatterPlotDescription': 'Dağılım çizimi',
	'scatterPlotDataSlot_yAxisLabel': 'Dikey eksen',
	'scatterPlotDataSlot_xAxisLabel': 'Yatay eksen',
	'scatterPlotDataSlot_colorLabel': 'Renk:',
	'scatterPlotDataSlot_categoriesLabel': 'Noktalar',
	'stackedBarName': 'Yığın çubuk',
	'stackedBarDescription': 'Yığın çubuk',
	'stackedBarDataSlot_colorLabel': 'Renk:',
	'stackedBarDataSlot_valuesLabel': 'Değer',
	'stackedBarDataSlot_categoriesLabel': 'Eksen etiketi',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Değer',
	'stackedColumnName': 'Yığın sütun',
	'stackedColumnDescription': 'Yığın sütun',
	'stackedColumnDataSlot_colorLabel': 'Renk:',
	'stackedColumnDataSlot_valuesLabel': 'Değer',
	'stackedColumnDataSlot_categoriesLabel': 'Eksen etiketi',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Değer',
	'summaryChartName': 'Özet',
	'summaryChartDescription': 'Özet',
	'summaryChartDataSlot_valuesLabel': 'Değer',
	'treeMapName': 'Ağaç eşlemi',
	'treeMapDescription': 'Ağaç eşlemi',
	'treeMapDataSlot_colorLabel': 'Isı:',
	'treeMapDataSlot_valuesLabel': 'Boyut:',
	'treeMapDataSlot_categoriesLabel': 'Düzey bir',
	'treeMapDataSlot_level3Label': 'Düzey üç',
	'treeMapDataSlot_level2Label': 'Düzey iki',
	'wordCloudName': 'Sözcük bulutu',
	'wordCloudDescription': 'Sözcük bulutu',
	'wordCloudDataSlot_colorLabel': 'Renk:',
	'wordCloudDataSlot_scaleLabel': 'Boyut:',
	'wordCloudDataSlot_wordLabel': 'Sözcükler',
	'treeMap1Cat1MeasureChartCaption': 'Ağaç eşlemi',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Düzey bir',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Boyut:',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Renk paletleri',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Renk paletleri',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Renk paletleri',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Renk paletleri',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Renk paletleri',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Renk paletleri',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Boş olanı gizle',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Açıklamayı gizle',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Açıklamayı gizleyin.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Açıklama konumu',
	'wordChart1Cat1MeasureCaption': 'Sözcük bulutu',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Sözcükler',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Boyut:',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Renk paletleri',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Sözcük rengi',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Eksen ölçeğini koru',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Eksenlerdeki minimum ve maksimum değerleri her zaman görüntüleyin.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Boş olanı gizle',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'İlişkili değeri olmayan kategorileri gizleyin.',
	'missingDataSetData': 'Bu veri kümesi için veriler kullanılamıyor. Kaynağa erişim için veri kümesini yenileyin veya sistem yöneticinizle görüşün.',
	'hideShowSummaries': 'Özetleri gizle göster',
	'crosstabName': 'Çapraz tablo',
	'value_is_not_available': 'Yok',
	'swapRowsAndColumns': 'Satırların ve sütunların yerini değiştir',
	'NoPinsCollected': 'Sabitlenmiş görselleştirme yok',
	'pinSearchOld': 'Sabitlediklerimi ara',
	'pinDeletedToast': 'Sabitleme kaldırıldı',
	'pinAddedToast': 'Sabitleme başarıyla Sabitlediklerim\'e eklendi',
	'pinRetrieveError': 'Bir veya daha fazla işaretleneni alamıyoruz. Daha sonra yeniden dene.',
	'pinErrorTitle': 'Sabitleme Hatası',
	'renamePinTooltip': 'Bir ad girin...',
	'renamePinInvalidText': 'Bu alan zorunludur.',
	'pinRemove': 'Kaldır',
	'deletePin': 'Sabitlemeyi sil',
	'renamePin': 'Yeniden adlandır',
	'cancelRenamePin': 'İptal',
	'confirmRenamePin': 'Bitti',
	'dataset_time': 'saat',
	'dataset_date': 'tarih',
	'dataset_location': 'konum',
	'dataset_number': 'numara',
	'dataset_text': 'metin',
	'widgetConditionalFormatLabel': 'Koşullu biçim denetimlerini aç/kapat',
	'deletePinConfirmationMessage': 'Bu sabitlemeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
	'deletePinConfirm': 'Silmeyi onayla',
	'pinDeleteError': 'Bir veya daha fazla işaretleneni silemiyoruz. Daha sonra yeniden dene.',
	'metadataPickerTitle': 'Veri Kümesi Oluştur',
	'moreTitle': 'Daha fazla',
	'remove_slider_handle': 'Tutamacı kaldır',
	'missingFiltering': 'Sütun eksik:',
	'unSupportedPromptType': 'Bilgi istemi senaryosu şu anda desteklenmiyor.',
	'preAggregateLabel': 'Veri kaynağından bilgi istemi değerlerini uygula',
	'postAggregateLabel': 'Raporda bilgi istemi değerlerini uygula',
	'preAggregateText': 'Aralık, gösterge panosunda görüntülenen değerleri değil, veri kaynağındaki değerleri kullanır.',
	'tabName_general': 'Genel', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Ayrıntılar',
	'tabName_textDetails': 'Metin ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Ortam ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Web sayfası ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Resim ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Görselleştirme',
	'sectionName_canvas': 'Tuval',
	'sectionName_colorsAndThemes_v1': 'Renk ve tema',
	'sectionName_colorsAndThemes': 'Tema ve arkaplan',
	'colorsAndThemes_legacyWarning': 'Geçerli gösterge panosu önceki yayın düzeylerinden bir tema kullanıyor. Temanın değiştirilmesi ve gösterge panosunun kalıcı olarak kaydedilmesi önceki tema paletlerine erişimi kaldırır. ',
	'sectionName_details': 'Ayrıntılar',
	'sectionName_positionAndStyle': 'Konum ve stil',
	'sectionName_appearance': 'Görünüş', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Gelişmiş',
	'sectionName_layout': 'Düzen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Sekme etiketleri',
	'sectionName_tabTitle': 'Etiket',
	'sectionName_tabBackground': 'Arka plan',
	'addDataSourceDialogTitle': 'Veri kaynağı ekle',
	'addDataSourceDialogButtonLabel': 'Ekle',
	'shapesDoubleChevron': 'Köşeli çift ayraç',
	'widgetsPanelTitle': 'Pencere öğeleri',
	'widgetsPanelBasicsTab': 'Temel bilgiler',
	'widgetsPanelImageLibraryTab': 'Resimler',
	'widgetsPanelSectionStandard': 'Standart',
	'widgetsPanelSectionAdvanced': 'Gelişmiş',
	'widgetsPanelSectionShapes': 'Şekiller',
	'customWidgetsTitle': 'Özel pencere öğeleri',
	'filterItemCanvasMove': 'Tuvale ekle',
	'filterOverflowMenu_Global': 'Tüm sekmeler için taşma menüsü',
	'filterOverflowMenu_Tab': 'Bu sekme için taşma menüsü',
	'filterOverflowMenu_Item': 'Süzgeç için taşma menüsü',
	'filterOverflowMenu_Single': 'Taşma menüsü',
	'filterItemEdit': 'Süzgeç değerlerini düzenle',
	'filterDeleteAllItems': 'Tüm süzgeçleri sil',
	'filterClearAllItems': 'Tüm süzgeçleri temizle',
	'filterClearSelection': 'Süzgeci temizle',
	'filterPlayerMode': 'Oynatıcıyı göster',
	'filterStaticMode': 'Listeyi göster',
	'filterInvertSelection': 'Süzgeci ters çevir',
	'filterIconLabel_Global': 'Tüm sekmeler',
	'filterIconLabel_Single': 'Süzgeçler',
	'filterIconLabel_Tab': 'Bu sekme',
	'filterIconTooltip_Global': 'Tüm sekmeler',
	'filterIconTooltip_Tab': 'Bu sekme',
	'filterIconTooltip_Single': 'Süzgeçler',
	'filterItemDelete': 'Süzgeci sil',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'şunun dışında her şey: %{from}-%{to}',
	'filterExcept': '%{values} dışında',
	'filterAll': 'Tümü',
	'filterBlank': '(boş)',
	'filterDisableRangeInvert': 'Bu sütun "Tüm sekmeler" süzgecinde yer alıyorsa kullanılamaz.',
	'filterDisableHierarchyInvert': 'Bu sütun bir sıradüzen süzgeci olduğunda kullanılamaz.',
	'filterSelectedOfTotal': '%{selected} / %{totalMembers}',
	'filter_date_before': '%{to} tarihinden önce',
	'filter_date_before_except': '%{to} öncesinde değil',
	'filter_date_after': '%{from} tarihinden sonra',
	'filter_date_after_except': '%{from} tarihinden sonra değil',
	'filter_date_between': '%{from} - %{to} arasında',
	'filter_date_between_except': '%{from} - %{to}arasında değil',
	'filter_drag_and_drop_all_tabs': 'Bütün sekmelere süzgeç uygulamak için verileri sürükleyip bırakın.',
	'filter_drag_and_drop_current_tab': 'Bu sekmeye süzgeç uygulamak için verileri sürükleyip buraya bırakın.',
	'filter_drag_and_drop_single_dock': 'Süzgeç uygulamak için verileri buraya sürükleyip bırakın.',
	'errMsgFilterItemGenericTitle': 'Süzgeç değerleri yüklenemedi',
	'widgetChromeRotate': 'Döndür',
	'toolbarRegionLabel': 'Araç çubuğu',
	'toolbarActionDelete': 'Sil',
	'toolbarActionGroup': 'Grup',
	'toolbarActionUngroup': 'Grubu çöz',
	'toolbarActionOrderToFront': 'En öne gönder',
	'toolbarActionOrderToBack': 'Arkaya gönder',
	'toolbarActionEditTitle': 'Başlığı düzenle',
	'toolbarActionWrapTitle': 'Başlığı kaydır',
	'toolbarActionPin': 'Topla',
	'toolbarActionPinOld': 'Sabitle',
	'toolbarActionAlign': 'Hizala',
	'alignWidgetLeft': 'Sol',
	'alignWidgetCenter': 'Orta',
	'alignWidgetRight': 'Sağ',
	'alignWidgetTop': 'Üst',
	'alignWidgetMiddle': 'Orta',
	'alignWidgetBottom': 'Alt',
	'distributeWidgetsVertical': 'Dikey dağıt',
	'distributeWidgetsHoriz': 'Yatay olarak dağıt',
	'toolbarChangeVisualization': 'Görselleştirmeyi değiştir',
	'multipurposeHeader': 'Bir pencere öğesi tipi seçin',
	'multipurposePlaceholderText': 'Başlamak için pencere öğelerinden birini seçin. ',
	'live_label': 'Grafik',
	'filter_label': 'Süzgeç',
	'one_named_live': '%{name} grafiği',
	'one_named_live_numbered': '%{name} grafiği (%{number})',
	'one_unknown_live': 'Grafik',
	'one_unknown_live_numbered': 'Grafik (%{number})',
	'few_live': '%{count} grafik grubu',
	'many_live': '%{count} grafik grubu',
	'one_custom': 'Özel pencere öğesi',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} süzgeci',
	'one_named_filter_numbered': '%{name} süzgeci (%{number})',
	'one_unknown_filter': 'Süzgeç',
	'one_unknown_filter_numbered': 'Süzgeç (%{number})',
	'few_filter': '%{count} süzgeç grubu',
	'many_filter': '%{count} süzgeç grubu',
	'LIVE_bar_has_mapping': '%{values} çubuk grafiği',
	'LIVE_bar_has_mapping_numbered': '%{values} çubuk grafik (%{number})',
	'LIVE_bar_opt_mapping': '%{values} çubuk grafiğine göre %{categories}',
	'LIVE_bar_opt_mapping_numbered': '%{values} çubuk grafiğine göre %{categories} ({number})',
	'LIVE_bar_no_mapping': 'Boş çubuk grafik',
	'LIVE_bar_no_mapping_numbered': 'Boş çubuk grafik (%{number})',
	'LIVE_bar_named': '%{name} çubuk grafiği',
	'LIVE_bar_named_numbered': '%{name} çubuk grafiği (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} yığın çubuk grafiği',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} yığın çubuk grafiği (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{values} yığın çubuk grafiğine göre %{categories}',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{values} yığın çubuk grafiğine göre %{categories} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Boş yığın çubuk grafik',
	'LIVE_stacked_bar_no_mapping_numbered': 'Boş yığın çubuk grafiği (%{number})',
	'LIVE_stacked_bar_named': '%{name} yığın çubuk grafiği',
	'LIVE_stacked_bar_named_numbered': '%{name} yığın çubuk grafiği (%{number})',
	'LIVE_bubble_has_mapping': '%{x} ve %{y} kabarcık grafiğine göre %{categories}',
	'LIVE_bubble_has_mapping_numbered': '%{x} ve %{y} kabarcık grafiğine göre %{categories} (%{number})',
	'LIVE_bubble_no_mapping': 'Boş kabarcık grafiği',
	'LIVE_bubble_no_mapping_numbered': 'Boş kabarcık grafiği (%{number})',
	'LIVE_bubble_named': '%{name} kabarcık grafiği',
	'LIVE_bubble_named_numbered': '%{name} kabarcık grafiği (%{number})',
	'LIVE_composite_has_mapping': '%{columnValue} ve  %{lineValue} bileşik grafiğine göre %{categories}',
	'LIVE_composite_has_mapping_numbered': '%{columnValue} ve %{lineValue} bileşik grafiğine göre %{categories}  (%{number})',
	'LIVE_composite_no_mapping': 'Boş bileşik grafik',
	'LIVE_composite_no_mapping_numbered': 'Boş bileşik grafik (%{number})',
	'LIVE_composite_named': '%{name} bileşik grafiği',
	'LIVE_composite_named_numbered': '%{name} bileşik grafiği (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} karar ağacı',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} karar ağacı (%{number})',
	'LIVE_decision_tree_no_mapping': 'Boş karar ağacı',
	'LIVE_decision_tree_no_mapping_numbered': 'Boş karar ağacı (%{number})',
	'LIVE_decision_tree_named': '%{name} karar ağacı',
	'LIVE_decision_tree_named_numbered': '%{name} karar ağacı (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} paketli kabarcık grafiği',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} paketli kabarcık grafiği (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Boş paketlenmiş kabarcık grafiği',
	'LIVE_packed_bubble_no_mapping_numbered': 'Boş paketli kabarcık grafiği (%{number})',
	'LIVE_packed_bubble_named': '%{name} paketli kabarcık grafiği',
	'LIVE_packed_bubble_named_numbered': '%{name} paketli kabarcık grafiği (%{number})',
	'LIVE_pie_has_mapping': '%{values} pasta grafiğine göre %{categories}',
	'LIVE_pie_has_mapping_numbered': '%{values} pasta grafiğine göre %{categories} (%{number})',
	'LIVE_pie_no_mapping': 'Boş pasta grafik',
	'LIVE_pie_no_mapping_numbered': 'Boş pasta grafik (%{number})',
	'LIVE_pie_named': '%{name} pasta grafiği',
	'LIVE_pie_named_numbered': '%{name} pasta grafiği (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{values} halka grafiğine göre %{categories}',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{values} halka grafiğine göre %{categories} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Boş halka grafiği',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Boş halka grafik (%{number})',
	'LIVE_pie_as_donut_named': '%{name} halka grafiği',
	'LIVE_pie_as_donut_named_numbered': '%{name} halka grafiği (%{number})',
	'LIVE_line_has_mapping': '%{values} çizgi grafiğine göre %{categories}',
	'LIVE_line_has_mapping_numbered': '%{values} çizgi grafiğine göre %{categories} (%{number})',
	'LIVE_line_no_mapping': 'Boş çizgi grafik',
	'LIVE_line_no_mapping_numbered': 'Boş çizgi grafik (%{number})',
	'LIVE_line_named': '%{name} çizgi grafiği',
	'LIVE_line_named_numbered': '%{name} çizgi grafiği (%{number})',
	'LIVE_area_has_mapping': '%{values} alan grafiğine göre %{categories}',
	'LIVE_area_has_mapping_numbered': '%{values} alan grafiğine göre %{categories} (%{number})',
	'LIVE_area_no_mapping': 'Boş alan grafiği',
	'LIVE_area_no_mapping_numbered': 'Boş alan grafiği (%{number})',
	'LIVE_area_named': '%{name} alan grafiği',
	'LIVE_area_named_numbered': '%{name} alan grafiği (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{values} yığın yüzde alan grafiğine göre %{categories}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{values} yığın yüzde alan grafiğine göre %{categories} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Boş yığın yüzde alan grafiği',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Boş yığın yüzde alan grafiği (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} yığın yüzde alan grafiği',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} yığın yüzde alan grafiği (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} ısı haritası',
	'LIVE_heatmap_has_mapping_numbered': '%{color} ısı haritası (%{number})',
	'LIVE_heatmap_no_mapping': 'Boş ısı haritası',
	'LIVE_heatmap_no_mapping_numbered': 'Boş ısı haritası (%{number})',
	'LIVE_heatmap_named': '%{name} ısı haritası',
	'LIVE_heatmap_named_numbered': '%{name} ısı haritası (%{number})',
	'LIVE_network_opt_mapping': '%{series} ve %{values} ağına göre %{categories}',
	'LIVE_network_opt_mapping_numbered': '%{series} ve %{values} ağına göre %{categories} (%{number})',
	'LIVE_network_has_mapping': '%{series} ağına göre %{categories}',
	'LIVE_network_has_mapping_numbered': '%{series} ağına göre %{categories} (%{number})',
	'LIVE_network_no_mapping': 'Boş ağ',
	'LIVE_network_no_mapping_numbered': 'Boş ağ (%{number})',
	'LIVE_network_named': '%{name} ağı',
	'LIVE_network_named_numbered': '%{name} ağı (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{values} radyal çubuk grafiğine göre %{categories}',
	'LIVE_radial_bar_opt_mapping_numbered': '%{values} radyal çubuk grafiğine göre %{categories} (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} radyal çubuk grafiği',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} radyal çubuk grafiği (%{number})',
	'LIVE_radial_bar_no_mapping': 'Boş radyal çubuk grafiği',
	'LIVE_radial_bar_no_mapping_numbered': 'Boş radyal çubuk grafiği (%{number})',
	'LIVE_radial_bar_named': '%{name} radyal çubuk grafiği',
	'LIVE_radial_bar_named_numbered': '%{name} radyal çubuk grafiği (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spiral grafiği',
	'LIVE_spiral_has_mapping_numbered': '%{values} spiral grafiği (%{number})',
	'LIVE_spiral_no_mapping': 'Boş spiral grafik',
	'LIVE_spiral_no_mapping_numbered': 'Boş spiral grafik (%{number})',
	'LIVE_spiral_named': '%{name} spiral grafiği',
	'LIVE_spiral_named_numbered': '%{name} spiral grafiği (%{number})',
	'LIVE_treemap_has_mapping': '%{size} ağaç eşlemine göre %{categories}',
	'LIVE_treemap_has_mapping_numbered': '%{size} ağaç eşlemine göre %{categories} (%{number})',
	'LIVE_treemap_no_mapping': 'Boş ağaç eşlemi',
	'LIVE_treemap_no_mapping_numbered': 'Boş ağaç eşlemi (%{number})',
	'LIVE_treemap_named': '%{name} ağaç eşlemi',
	'LIVE_treemap_named_numbered': '%{name} ağaç eşlemi (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} sözcük bulutu',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} sözcük bulutu (%{number})',
	'LIVE_wordcloud_no_mapping': 'Boş sözcük bulutu',
	'LIVE_wordcloud_no_mapping_numbered': 'Boş sözcük bulutu (%{number})',
	'LIVE_wordcloud_named': '%{name} sözcük bulutu',
	'LIVE_wordcloud_named_numbered': '%{name} sözcük bulutu (%{number})',
	'LIVE_data_player_has_mapping': '%{category} veri oynatıcısı',
	'LIVE_data_player_has_mapping_numbered': '%{category} veri oynatıcısı (%{number})',
	'LIVE_data_player_no_mapping': 'Boş veri oynatıcısı',
	'LIVE_data_player_no_mapping_numbered': 'Boş veri oynatıcı (%{number})',
	'LIVE_data_player_named': '%{name} veri oynatıcısı',
	'LIVE_data_player_named_numbered': '%{name} veri oynatıcısı (%{number})',
	'LIVE_map_has_mapping': '%{locations} haritası',
	'LIVE_map_has_mapping_numbered': '%{locations} haritası (%{number})',
	'LIVE_map_no_mapping': 'Boş harita',
	'LIVE_map_no_mapping_numbered': 'Boş harita (%{number})',
	'LIVE_map_named': '%{name} haritası',
	'LIVE_map_named_numbered': '%{name} haritası (%{number})',
	'LIVE_point_has_mapping': '%{values} nokta grafiğine göre %{categories}',
	'LIVE_point_has_mapping_numbered': '%{values} nokta grafiğine göre %{categories} (%{number})',
	'LIVE_point_no_mapping': 'Boş nokta grafik',
	'LIVE_point_no_mapping_numbered': 'Boş nokta grafiği (%{number})',
	'LIVE_point_named': '%{name} nokta grafiği',
	'LIVE_point_named_numbered': '%{name} nokta grafiği (%{number})',
	'LIVE_column_has_mapping': '%{values} sütun grafiği',
	'LIVE_column_has_mapping_numbered': '%{values} sütun grafiği (%{number})',
	'LIVE_column_opt_mapping': '%{values} sütun grafiğe göre %{categories}',
	'LIVE_column_opt_mapping_numbered': '%{values} sütun grafiğine göre %{categories} (%{number})',
	'LIVE_column_no_mapping': 'Boş sütun grafik',
	'LIVE_column_no_mapping_numbered': 'Boş sütun grafiği (%{number})',
	'LIVE_column_named': '%{name} sütun grafiği',
	'LIVE_column_named_numbered': '%{name} sütun grafiği (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} yığın sütun grafiği',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} yığın sütun grafiği (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{values} sütun grafiğe göre %{categories}',
	'LIVE_stacked_column_opt_mapping_numbered': '%{values} yığın sütun grafiğine göre %{categories} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Boş yığın sütun grafiği',
	'LIVE_stacked_column_no_mapping_numbered': 'Boş yığın sütun grafiği (%{number})',
	'LIVE_stacked_column_named': '%{name} yığın sütun grafiği',
	'LIVE_stacked_column_named_numbered': '%{name} yığın sütun grafiği (%{number})',
	'LIVE_scatter_opt_mapping': '%{x} ve  %{y} dağılım çizimine göre %{categories}',
	'LIVE_scatter_opt_mapping_numbered': '%{x} ve %{y} dağılım çizimine göre %{categories}  (%{number})',
	'LIVE_scatter_has_mapping': '%{x} ve %{y} dağılım çizimi karşılaştırması',
	'LIVE_scatter_has_mapping_numbered': '%{x} ve %{y} dağılım çizimi karşılaştırması (%{number})',
	'LIVE_scatter_no_mapping': 'Boş dağılım çizimi',
	'LIVE_scatter_no_mapping_numbered': 'Boş dağılım çizimi (%{number})',
	'LIVE_scatter_named': '%{name} dağılım çizimi',
	'LIVE_scatter_named_numbered': '%{name} dağılım çizimi (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} şelale grafiği',
	'LIVE_waterfall_has_mapping_numbered': '%{values} şelale grafiği (%{number})',
	'LIVE_waterfall_no_mapping': 'Boş şelale grafiği',
	'LIVE_waterfall_no_mapping_numbered': 'Boş şelale grafiği (%{number})',
	'LIVE_waterfall_named': '%{name} şelale grafiği',
	'LIVE_waterfall_named_numbered': '%{name} şelale grafiği (%{number})',
	'LIVE_empty_visualization_hint_title': 'Görselleştirmenizi oluşturun',
	'LIVE_empty_visualization_hint_description': 'Sütunları sürükleyip buraya ya da sol taraftaki yuvalara bırakın.',
	'LIVE_slots_required_field_description': '%{asterisk} Zorunlu bir alanı belirtir',
	'LIVE_slots_drag_and_drop_description': 'Görselleştirmeyi oluşturup süzgeçten geçirmek için verileri yukarıdaki yuvalara sürükleyip bırakın.',
	'requiredField': 'Zorunlu Alan',
	'fullScreenEnter': 'Tam ekrana gir',
	'fullScreenClose': 'Tam ekrandan çık',
	'noExtraText_multipurpose': 'Çok amaçlı yer tutucu',
	'noExtraText_multipurpose_numbered': 'Çok amaçlı yer tutucu (%{number})',
	'one_placeholder_vis': 'Görselleştirme yer tutucusu',
	'one_placeholder_vis_numbered': 'Görselleştirme yertutucusu (%{number})',
	'one_placeholder_text': 'Metin yer tutucusu',
	'one_placeholder_text_numbered': 'Metin yer tutucusu (%{number})',
	'few_placeholder_text': '%{count} metin yer tutucusu grubu',
	'many_placeholder_text': '%{count} metin yer tutucusu grubu',
	'filter_includesAll': 'Tümünü içerir',
	'timeline_filter_moved_to': 'Zaman çizgisi süzgeci %{id}, %{time} hedefine taşındı',
	'timelineSettingsButton': 'Kayıttan yürütme seçenekleri',
	'autoPlay': 'Tüm sahneleri oynat',
	'loop': 'Döngü',
	'noSceneTransitionLabel': 'Yok',
	'sceneTransitionPropertyLabel': 'Sahne geçişi',
	'animatedPathSceneTransitionLabel': 'Animasyonlu yol',
	'sweepSceneTransitionLabel': 'Tarama',
	'propAniAnimation': 'Animasyon',
	'propAniTypeEntrance': 'Giriş animasyonu',
	'propAniDirectionIn': 'Giriş yönü',
	'propAniTypeExit': 'Çıkış animasyonu',
	'propAniDirectionOut': 'Çıkış yönü',
	'propAniDirection': 'Yön',
	'timelineAnimationProperties': 'Animasyon özelliklerini aç',
	'editStoryCoachMarkTitle': 'Hikayeyi düzenle',
	'editStoryCoachMarkContents': 'Bu hikayeyi düzenlemek için kalem simgesini tıklatın.',
	'addDataStoryCoachMarkContents': 'Veri panosundan hikayenize verileri sürükleyip bırakın.',
	'expandSceneCoachmarkTitle': 'Zaman çizelgesini aç',
	'expandSceneCoachmarkContents': 'Zaman ve süreye göre nesne görünürlüğünü ayarlayarak bir sahne canlandırın.',
	'overviewCoachmarkTitle': 'Genel bakış sahneleri',
	'overviewCoachmarkContents': 'Tüm sahnelerin büyük resmini göstermek için hikayenizin başında ve sonunda genel bakış sahnelerini kullanın. Bir sahneyi başka bir sahneyle değiştirmek için genel bakış sahnesinde ilgili sahneyi tıklatın ve sürükleyin. Hikaye özelliklerinde genel bakış sahnelerini gösterebilir veya gizleyebilirsiniz.',
	'animatedPathCoachmarkTitle': 'Animasyonlu yol',
	'animatedPathCoachmarkContents': 'Bir sahneden diğerine doğru nesneye animasyon uygulamak için nesne içeren bir sahneyi çoğaltın. Ardından yeni sahnede çoğaltılan nesneyi taşıyın, yeniden boyutlandırın ya da döndürün.',
	'tabName_animation': 'Animasyon',
	'textWidgetIconPlaceholderText': 'Metin eklemek için tıklatın',
	'buildVisHeader': 'Görselleştirme oluşturma',
	'visIconPlaceholderText': 'Görselleştirme oluşturmak için alanları sürükleyin ve bırakın',
	'launchNewExplore': 'Yeni keşif',
	'addTo': 'Ekle',
	'addToExisting': 'Var olana ekle...',
	'exploreData': 'Gez',
	'explore_remove_widget_styles': 'Renk ayarları gibi özel görselleştirme özellikleri, keşfinizde kalıcı olmaz.',
	'editNotebook': 'Pencere Öğesini Düzenle',
	'thumbnails_error_fetching': 'Küçük resimler getirilirken hata oluştu',
	'copy': '%{count} varlık kopyalandı',
	'specConvertErr': 'Gösterge panosu belirtimi yapıştırılırken ya da dönüştürülürken bir hata oluştu',
	'specCopyErr': 'Gösterge panosu belirtimi kopyalanırken hata oluştu',
	'pasteNotSupportedErr': 'Bir %{name} kaynağından yapıştırma desteklenmez.',
	'reportParam': 'rapor',
	'filterWidgetCopyWarn': 'Süzgeçler şu anda desteklenmediğinden süzgeç görselleştirmesi kopyalanmadı.',
	'upgradingDashboard': '%{version} için "%{name}" yükseltiliyor...',
	'upgradeComplete': 'Yükseltme tamamlandı',
	'individualTabProperties': 'Tek tek sekme özellikleri',
	'propMasterTabStylesLabel_v1': 'Genel sekme stili',
	'propMasterTabStylesLabel': 'Tüm sekme stilleri',
	'propTabPosition': 'Sekme konumu',
	'propTabTitle': 'Başlık',
	'propTabBackgroundColor': 'Dolgu rengi',
	'propTabTextColor': 'Başlık rengi',
	'propTabSelectedBarColor': 'Seçili çubuk rengi',
	'propTabRestoreDefaults': 'Varsayılanları geri yükle',
	'propIndividualTabStylesLabel': 'Tek sekme stili',
	'propIndividualTabStylesAriaLabel': 'Tek sekme stili özelliklerini aç',
	'propTabIconPosition': 'Simge konumu',
	'propLeftTitle': 'Başlığın solu',
	'propRightTitle': 'Başlığın sağı',
	'propTopTitle': 'Başlığın üstü',
	'propBottomTitle': 'Başlığın altı',
	'propTabIconLabel': 'Görsel',
	'propTabIcon': 'Simge',
	'propTabIconColor': 'Simge rengi',
	'no_icon': 'Boş',
	'announcement': 'Duyuru',
	'api': 'Api',
	'archive': 'Arşiv',
	'asset': 'Varlık',
	'attachment': 'Ek',
	'audio': 'Ses',
	'bee': 'Bee',
	'blog': 'Blog',
	'bookmark': 'Yer İşareti',
	'calendar': 'Takvim',
	'camera': 'Kamera',
	'capability': 'Yetenek',
	'catalog': 'Katalog',
	'chat_message': 'Sohbet iletisi',
	'checkout_cart': 'Sepet için ödeme yap',
	'client': 'İstemci',
	'clock': 'Saat',
	'cloud': 'Bulut',
	'code': 'Kod',
	'data_quality': 'Veri kalitesi',
	'folder': 'Klasörler',
	'forum': 'Forum',
	'glasses': 'Gözlük',
	'group': 'Grup',
	'hat': 'Şapka',
	'headphone': 'Kulaklık',
	'hills': 'Tepeler',
	'home': 'Ana Ekran',
	'idea': 'Fikir',
	'image': 'Resim',
	'inventory': 'Stok',
	'like': 'Beğen',
	'link': 'Bağlantı',
	'location': 'Yer',
	'manage': 'Yönet',
	'pen': 'Kalem',
	'mobile_phone': 'Cep telefonu',
	'music': 'Müzik',
	'notifications': 'Bildirimler',
	'paint': 'Boya',
	'payment': 'Ödeme',
	'password_key': 'Parola anahtarı',
	'people': 'Kişiler',
	'person': 'Kişi',
	'phone': 'Telefon',
	'pin': 'Sabitle',
	'print': 'Yazdır',
	'recording': 'Kaydediliyor',
	'repository': 'Havuz',
	'role': 'Rol',
	'search': 'Ara',
	'properties': 'Özellikler',
	'speaker': 'Konuşmacı',
	'star': 'Yıldız',
	'tag': 'Etiket',
	'thumbs_up': 'Başparmak yukarı',
	'thumbs_down': 'Başparmak aşağı',
	'tools': 'Araçlar',
	'traffic': 'Trafik',
	'trash': 'Çöp Kutusu',
	'twitter': 'Twitter',
	'unknown': 'Bilinmiyor',
	'user': 'Kullanıcı',
	'venn_diagram': 'Venn çizgesi',
	'video': 'Video',
	'view': 'Görünüm',
	'warning': 'Uyarı',
	'watch': 'Gözle',
	'watson': 'Watson',
	'wikis': 'Vikiler',
	'workspace': 'Çalışma Alanı',
	'world': 'Dünya',
	'eventGroupButtonLabel': 'Pencere öğesi bağlantılarını görüntüle',
	'dockToolbar': 'Araç çubuğunu yerleştir',
	'undockToolbar': 'Araç çubuğunu kaldır',
	'propShowTitle': 'Başlığı göster',
	'textAutoFontSize': 'Otomatik',
	'zoomFitToWidth': 'Genişliğe uydur',
	'zoomWholePage': 'Sayfaya sığdır',
	'defaultZoomValue': 'Varsayılan yakınlaştırma değeri',
	'zoomCategoryLabel': 'Sayfa yakınlaştırma (Yalnızca mutlak düzen)'
});
